/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedDepositPaymentDetail_item$ref = any;
type PdpSharedDetailPayments_item$ref = any;
type PdpSharedDetailReturnPolicy_item$ref = any;
type PdpSharedDetailShipping_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespShippingReturns_item$ref: FragmentReference;
export type PdpRespShippingReturns_item = {|
  +isAvailable: ?boolean,
  +isSold: ?boolean,
  +hasActiveHoldForBuyer?: ?boolean,
  +$fragmentRefs: PdpSharedDetailPayments_item$ref & PdpSharedDetailReturnPolicy_item$ref & PdpSharedDepositPaymentDetail_item$ref & PdpSharedDetailShipping_item$ref,
  +$refType: PdpRespShippingReturns_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespShippingReturns_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailPayments_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailReturnPolicy_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDepositPaymentDetail_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_item",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isAvailable",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isSold",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchUser",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasActiveHoldForBuyer",
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId",
              "type": "String!"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'fde5b5e4d7bc4dfb2a9440aeab581f60';
module.exports = node;
